import React from 'react';
import { PropTypes } from 'prop-types';

import FavoriteIcon from '@icons/FavoriteIcon';
import { SAVED_ITEMS_QUERY } from '@general/graphql/viewer.graph';
import getFavoriteHook from '@hooks/getFavoriteHook';

// Component normalizes props for FavoriteIcon
// some props not snakeCase because they are passed through html
const Favorite = ({ id, type, format, isFavorite: initialIsFavorite }) => {
    const useFavorite = getFavoriteHook({ type, initialIsFavorite, readItemQuery: SAVED_ITEMS_QUERY });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite } = useFavorite();

    let tooltipPlacement;
    let tooltipPlacementMobile;
    let marginRight;

    if (format === 'bigCard') {
        tooltipPlacement = 'bottom';
        tooltipPlacementMobile = 'left';
    }

    if (format === 'bar') {
        tooltipPlacement = 'left';
        tooltipPlacementMobile = 'top';
    }

    if (format === 'tightCard') {
        marginRight = 'mr-3';
    }

    const onClick = () => {
        // eslint-disable-next-line no-unused-expressions
        isFavorite ? removeFavorite(id) : saveFavorite(id);
    };

    return (
        <FavoriteIcon
            id={id}
            type={type}
            tooltipPlacement={tooltipPlacement}
            tooltipPlacementMobile={tooltipPlacementMobile}
            isFavorite={isFavorite}
            isLoading={isLoadingFavorite}
            onClick={onClick}
            marginRight={marginRight}
        />
    );
};

Favorite.propTypes = {
    isFavorite: PropTypes.bool,
    id: PropTypes.number,

    // article, bookstore, company, event, member, press, publication, session
    type: PropTypes.string,
    // bigCard, bar, smallCard
    format: PropTypes.string,
};

export default Favorite;
